import { useCallback } from "react"
import { useAccount } from "wagmi"

import {
  RootState,
  selectIsConnected,
  selectTokenDecimals,
  setOpenModal,
  useDappDispatch,
  useDappSelector,
} from "#/redux-state"
import { MezoNativeBTC } from "#/shared/constants/artifacts"
import { useERC20TokenBalance } from "#/shared/hooks"
import { bigIntToFloat } from "#/shared/utils"
import { ComponentStepProps, useStepperModalContext } from "#/ui/Modal"

import { StakingForm, StakingFormValue } from "../components"

export default function StakeAndLockStep({
  onClickContinue,
}: ComponentStepProps) {
  const { address } = useAccount()
  const { data: balance } = useERC20TokenBalance(MezoNativeBTC.address, address)

  const { values: initialValues, setValues } =
    useStepperModalContext<StakingFormValue>()

  const dispatch = useDappDispatch()
  const isConnected = useDappSelector(selectIsConnected)

  const tokenDecimals = useDappSelector((state: RootState) =>
    selectTokenDecimals(state, "mBTC"),
  )

  const handelConnectWallet = useCallback(() => {
    dispatch(setOpenModal("onboarding"))
  }, [dispatch])

  const handelSubmitForm = useCallback(
    (values: StakingFormValue) => {
      setValues(values)
      onClickContinue()
    },
    [onClickContinue, setValues],
  )

  return (
    <StakingForm
      initialValues={initialValues}
      onSubmitForm={handelSubmitForm}
      token="BTC"
      tokenDecimals={tokenDecimals}
      balance={bigIntToFloat(balance ?? 0n)}
      {...(!isConnected && {
        shouldSkipValidation: true,
        buttonLabel: "Sign-in to stake",
        onButtonClick: handelConnectWallet,
      })}
      withLockDuration
    />
  )
}
